import { Grid, GridItem, Text, VStack } from "@chakra-ui/react";

const cellStyle = {
  borderBottom: "1px solid",
  borderColor: "gray.100",
  minH: "50px",
  px: { base: 3, md: 2 },
  py: 1,
};

export default function UnifiedKeyValueGrid({ items = [] }) {
  if (!items.length) return null;

  const pairs = [];
  for (let index = 0; index < items.length; index += 2) {
    pairs.push(items.slice(index, index + 2));
  }

  return (
    <VStack spacing={0} align="stretch" bg="white" borderRadius="xl"
     overflow="hidden" border="1px solid"
      borderColor="gray.100"
      >
      {pairs.map((pair, rowIndex) => (
        <Grid key={`row-${rowIndex}`} templateColumns={{ base: "1fr", md: "repeat(2, 1fr)" }}>
          {pair.map((item, itemIndex) => (
            <GridItem
              colSpan={1}
              key={`${item.label}-${item.value}-${itemIndex}`}
              {...cellStyle}
              borderInlineEnd={{ base: "0", md: itemIndex === 0 && pair.length > 1 ? "1px solid" : "0" }}
              borderColor="gray.100"
            >
              <Text fontSize="sm" color="gray.500" mb={1}>
                {item.label}
              </Text>
              <Text fontSize={{ base: "md", md: "lg" }} fontWeight="bold" color="gray.800" lineHeight="1.5">
                {item.value}
              </Text>
            </GridItem>
          ))}
          {pair.length === 1 ? <GridItem display={{ base: "none", md: "block" }} {...cellStyle} /> : null}
        </Grid>
      ))}
    </VStack>
  );
}
